import {
    clearPersistedExperiment,
} from './abExperiment';
import {
    getMarketplaceCohort,
    getMarketplaceDebugCohort,
    MARKETPLACE_BUCKETS,
    MARKETPLACE_BUCKET_WEIGHTS,
    MARKETPLACE_COHORT_SETTING_KEY,
    MARKETPLACE_DEBUG_OVERRIDE_KEY,
    MARKETPLACE_EXPERIMENT_ID,
    MARKETPLACE_EXPERIMENT_SETTING_KEY,
    setMarketplaceDebugCohort,
} from './marketplaceExperiment';
import {
    BILLING_PERIOD_BUCKETS,
    BILLING_PERIOD_BUCKET_WEIGHTS,
    BILLING_PERIOD_COHORT_SETTING_KEY,
    BILLING_PERIOD_EXPERIMENT_ID,
    BILLING_PERIOD_EXPERIMENT_SETTING_KEY,
    clearBillingPeriodExperiment,
    getBillingPeriodExperimentContext,
    setBillingPeriodCohort,
} from './billingPeriodExperiment';
export const EXPERIMENT_REGISTRY = [
    {
        id: BILLING_PERIOD_EXPERIMENT_ID,
        label: 'Billing period visibility',
        buckets: BILLING_PERIOD_BUCKETS,
        bucketWeights: BILLING_PERIOD_BUCKET_WEIGHTS,
        cohortSettingKey: BILLING_PERIOD_COHORT_SETTING_KEY,
        experimentSettingKey: BILLING_PERIOD_EXPERIMENT_SETTING_KEY,
        getBrowserCohort: () => getBillingPeriodExperimentContext()?.cohort ?? null,
        setBrowserCohort: setBillingPeriodCohort,
        clearBrowserAssignment: clearBillingPeriodExperiment,
        additionalKeys: [],
    },
    {
        id: MARKETPLACE_EXPERIMENT_ID,
        label: 'Marketplace',
        buckets: MARKETPLACE_BUCKETS,
        bucketWeights: MARKETPLACE_BUCKET_WEIGHTS,
        cohortSettingKey: MARKETPLACE_COHORT_SETTING_KEY,
        experimentSettingKey: MARKETPLACE_EXPERIMENT_SETTING_KEY,
        legacyKeys: null,
        getBrowserCohort: getMarketplaceCohort,
        getDebugCohort: getMarketplaceDebugCohort,
        setBrowserCohort: setMarketplaceDebugCohort,
        additionalKeys: [MARKETPLACE_DEBUG_OVERRIDE_KEY],
        resetBeforeChange: true,
    },
];

export const getExperimentCohort = (experiment, user) => {
    const debugCohort = experiment.getDebugCohort?.();
    if (debugCohort) {
        return { cohort: debugCohort, source: 'debug cookie' };
    }

    const accountCohort = user?.settings?.[experiment.cohortSettingKey];
    if (experiment.buckets.includes(String(accountCohort ?? '').trim().toUpperCase())) {
        return {
            cohort: String(accountCohort).trim().toUpperCase(),
            source: 'user.settings',
        };
    }

    const browserCohort = experiment.getBrowserCohort();
    if (browserCohort) {
        return { cohort: browserCohort, source: 'cookie' };
    }

    return { cohort: null, source: 'none' };
};

export const clearExperiment = (experiment) => {
    if (typeof experiment.clearBrowserAssignment === 'function') {
        experiment.clearBrowserAssignment();
        return;
    }

    clearPersistedExperiment({
        experimentId: experiment.id,
        legacyKeys: experiment.legacyKeys,
        additionalKeys: experiment.additionalKeys,
    });
};
